import { SVGProps } from 'react';

const Help = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			{...props}
			width="53"
			height="52"
			viewBox="0 0 53 52"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="mask0_10701_10681"
				mask-type="alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="53"
				height="52"
			>
				<rect x="0.5" width="52" height="52" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_10701_10681)">
				<path
					d="M35.5563 28.0878C35.652 28.1355 35.736 28.2009 35.8028 28.28C35.9452 28.4442 36.0147 28.6521 35.9974 28.8617C35.9825 29.0706 35.8813 29.2661 35.7144 29.4081C35.5877 29.5134 32.5573 32 27 32C21.4436 32 18.4132 29.5134 18.2864 29.4081C18.1193 29.2663 18.0177 29.0707 18.0026 28.8617C17.9853 28.6517 18.0552 28.4435 18.1981 28.2792C18.2648 28.2002 18.3485 28.1349 18.444 28.0872C18.5395 28.0396 18.6447 28.0108 18.7529 28.0025C18.861 27.9942 18.9699 28.0067 19.0726 28.0392C19.1753 28.0716 19.2696 28.1234 19.3495 28.1911C19.3977 28.2306 22.1032 30.3996 27 30.3996C31.9198 30.3996 34.5812 28.2488 34.6485 28.1945L34.6496 28.1936C34.7294 28.1255 34.8237 28.0734 34.9265 28.0406C35.0293 28.0079 35.1384 27.9952 35.2468 28.0033C35.3552 28.0114 35.4606 28.0402 35.5563 28.0878Z"
					fill="white"
					stroke="white"
				/>
			</g>
			<g clipPath="url(#clip0_10701_10681)">
				<path
					d="M33.0174 37.2623L32.7548 37.16H32.473H16.437C15.451 37.16 14.5 36.2826 14.5 35.013V13.644C14.5 12.3775 15.4499 11.5 16.437 11.5H37.562C38.5498 11.5 39.499 12.3762 39.499 13.645V32.049V32.0492L39.4998 39.7988C39.2534 39.7021 38.9904 39.5989 38.7142 39.4905C37.0587 38.841 34.9256 38.0054 33.0174 37.2623Z"
					stroke="white"
					strokeWidth="3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10701_10681">
					<rect
						width="28"
						height="32"
						fill="white"
						transform="translate(13 10)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Help;
